import { useMemo } from 'react';

import EntryPointsHelper from '@/utils/entry-points-helper';

const useDynamicLogoHeightEnabled = () => {
	const isDynamicLogoHeightEnabled = useMemo(
		() =>
			document.querySelector(
				`${EntryPointsHelper.entryPointSelector}[data-dynamic-logo-height="true"]`,
			),
		[],
	);

	return !!isDynamicLogoHeightEnabled;
};

export default useDynamicLogoHeightEnabled;
